// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';

import { removeAllRanges } from 'app/scripts/lib/util/removeAllRanges';
import { setDocumentTitle } from 'app/src/components/DocumentTitle';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveBoardName = function (this: any, e: any) {
  const boardInput = $('.js-board-name-input', this.$el);
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const val = boardInput?.val().trim();
  if (val === '') {
    boardInput.focus().select();
    return;
  }

  const traceId = Analytics.startTask({
    taskName: 'edit-board/name',
    source: 'boardScreen',
  });

  this.model.update(
    {
      traceId,
      name: val,
    },
    tracingCallback(
      {
        taskName: 'edit-board/name',
        traceId,
        source: 'boardScreen',
      },
      (_err, board) => {
        if (board) {
          Analytics.sendUpdatedBoardFieldEvent({
            field: 'name',
            source: 'boardScreen',
            containers: {
              board: {
                id: this.model.id,
              },
            },
            attributes: {
              taskId: traceId,
            },
          });
        }
      },
    ),
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const keyDownEvent = function (this: any, e: any) {
  if (getKey(e) === Key.Enter) {
    stopPropagationAndPreventDefault(e); // prevents new lines.
    this.stopRenaming();
    return;
  }

  if (getKey(e) === Key.Escape) {
    this.stopRenaming();
    return;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onInputChanged = function (this: any, e: any) {
  const input = this.el.querySelector('.js-board-name-input');

  // First, we set the input width to 0, then we can measure how wide it needs to be for the content.
  input.style.width = '0';
  let inputWidthForNewValue = input.offsetWidth;

  // An element's scrollLeft represents the amount the element has been scrolled.
  // Setting an element's scrollLeft actually scrolls the element rather than setting the value,
  // and it can only scroll as far as the content goes— so here we're scrolling all the way to
  // the end of the content by using an absurd number.
  input.scrollLeft = 1e10;
  // With the width set to zero and the input scrolled to the end of the content, the element's
  // scrollLeft value is the width of the content! Now we add that to the offset.
  inputWidthForNewValue += input.scrollLeft;

  // Here we make sure the input doesn't fall off the side of the page. The "-24" is for paddding.
  const boardHeader = this.el.querySelector('.js-board-header');
  const maxWidth = boardHeader.offsetWidth - 24;
  const inputWidth =
    inputWidthForNewValue < maxWidth ? inputWidthForNewValue : maxWidth;

  // Now we have an input that's only as wide as the content needs, without running off the page.
  input.style.width = inputWidth + 'px';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const startRenaming = function (this: any, e: any) {
  stopPropagationAndPreventDefault(e);

  if (this.isEditingName) {
    return;
  }

  const renameButton = this.el.querySelector('.js-rename-board');
  if (!renameButton) {
    return;
  }

  const inputWidth = renameButton.offsetWidth;

  _.defer(() => {
    $('.js-rename-board', this.$el).addClass('is-editing');
    return $('.js-board-name-input', this.$el)
      .val(this.model.get('name'))
      .css('width', inputWidth)
      .focus()
      .select();
  });

  this.isEditingName = true;
  Analytics.sendUIEvent({
    action: 'clicked',
    actionSubject: 'input',
    actionSubjectId: 'boardNameInput',
    source: 'boardScreen',
    containers: {
      board: {
        id: this.model.id,
      },
    },
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stopRenaming = function (this: any, e: any) {
  if (!this.isEditingName) {
    return;
  }

  // eslint-disable-next-line @trello/enforce-variable-case
  const $input = $('.js-rename-board', this.$el).removeClass('is-editing');
  if ($input.is(':focus')) {
    $input.blur();
  }
  removeAllRanges();

  this.isEditingName = false;
  this.saveBoardName();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateControllerTitle = function (this: any) {
  return setDocumentTitle(this.model.get('name'));
};
